import React from 'react';
import { Card, Image, Button, Icon } from 'semantic-ui-react';
import { Link } from 'react-router-dom';

const AgentCard = ({ agent }) => {
    return (
        <div className="agent-card">
            <Card fluid>
                <div className="agent-photo-container">
                    <Image
                        circular
                        size="medium"
                        src={agent.profilePicture ? `https://easyrent.s3.eu-central-1.amazonaws.com/Users/${agent.profilePicture}` : '/img/avatar.jpg'}
                        alt={`${agent.firstName} ${agent.lastName}`}
                    />
                </div>

                <Card.Content textAlign="center">
                    <Card.Header className="agent-name">
                        {agent.firstName} {agent.lastName}
                    </Card.Header>
                    {agent?.agentWebSiteDescription && <Card.Meta className="agent-title">
                        {agent?.agentWebSiteDescription}
                    </Card.Meta>}
                    {agent?.agentWebSiteWorkingPosition && <Card.Meta className="agent-title">
                        {agent?.agentWebSiteWorkingPosition}
                    </Card.Meta>}

                    <div className="contact-info">
                        <div className="contact-item">
                            <Icon name="phone" className="icon-color" />
                            <a href={`tel:${agent.mobilePhone}`} className="contact-link">
                                {agent.mobilePhone}
                            </a>
                        </div>

                        <div className="contact-item">
                            <Icon name="mail" className="icon-color" />
                            <a href={`mailto:${agent.email}`} className="contact-link">
                                {agent.email}
                            </a>
                        </div>
                    </div>

                    {/* Dealer Bilgileri (varsa ayrı olarak göster) */}
                    {(agent.dealerName || agent.dealerPhone || agent.dealerEmail) ? (
                        <div className="contact-info" style={{ marginTop: 10 }}>
                            {agent.dealerName ? (
                                <div className="contact-item">
                                    <Icon name="user" className="icon-color" />
                                    <span className="contact-link">{agent.dealerName}</span>
                                </div>
                            ) : null}
                            {agent.dealerPhone ? (
                                <div className="contact-item">
                                    <Icon name="phone" className="icon-color" />
                                    <a href={`tel:${agent.dealerPhone}`} className="contact-link">{agent.dealerPhone}</a>
                                </div>
                            ) : null}
                            {agent.dealerEmail ? (
                                <div className="contact-item">
                                    <Icon name="mail" className="icon-color" />
                                    <a href={`mailto:${agent.dealerEmail}`} className="contact-link">{agent.dealerEmail}</a>
                                </div>
                            ) : null}
                        </div>
                    ) : null}
                </Card.Content>

                <Card.Content extra>
                    <div className="agent-actions">
                        <Button
                            className="green-btn"
                            fluid
                            as={Link}
                            to={`/agent/${agent.id}`}
                            icon="user"
                            content="View Profile"
                        />
                    </div>
                </Card.Content>
            </Card>
        </div>
    );
};

export default AgentCard;
